export default {"src":"/_next/static/media/Croatia.72577a05.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};